import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './Image.module.css';

type ImageProps = {
  src: string;
  alt: string;
  className?: string;
  fallback?: React.JSX.Element;
  classNameLoaded?: string;
};

const Image = ({
  src,
  alt = '',
  fallback,
  className,
  classNameLoaded = '',
  ...props
}: ImageProps): React.JSX.Element => {
  const imageRef = useRef(null);

  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (imageRef.current && src) {
      imageRef.current.onerror = () => setIsError(true);
      imageRef.current.onload = () => setIsLoaded(true);
    }
  }, [imageRef, src]);

  if (!src && !fallback) {
    return null;
  }

  if (fallback && (isError || !src)) {
    return fallback;
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      ref={imageRef}
      onLoad={() => setIsLoaded(true)}
      onError={() => setIsError(true)}
      className={classNames(
        styles.image,
        isLoaded && !isError && classNames(styles.loaded, classNameLoaded),
        className
      )}
      {...props}
    />
  );
};

export default Image;
